<template>
  <div class="paper-container" v-loading="paperDetailLoading">
    <div class="paper-detail">
      <div class="paper-title flex items-center">
        <span class="paper-bg">论文</span>
        <span
          @click="clickPDFView"
          style="cursor: pointer"
          class="paper-title-style"
          v-if="paperData.url"
          >{{ paperData.title }}</span
        >
        <span class="paper-title-style" v-else>{{ paperData.title }}</span>
        <div
          v-for="(jcrItem, jcrIndex) in paperData.jcrPartitionList"
          :key="jcrIndex"
        >
          <div v-if="jcrItem" class="jcr-view ellipsis" :title="jcrItem">
            {{ jcrItem }}
          </div>
        </div>
      </div>

      <div
        style="
          width: 100%;
          border-bottom: 1px dashed #e8eaee;
          margin-top: 20px;
          margin-bottom: 6px;
        "
      ></div>
      <!-- 作者-->
      <collapse :default-height="37" :hide-control="false">
        <div class="flex items-center flex-wrap">
          <span class="textSpan noWrap" style="margin-top: 14px">作者：</span>
          <div
            v-if="
              (paperData.authorList == null ||
                paperData.authorList.length == 0) &&
              (paperData.authors == null || paperData.authors.length == 0)
            "
          >
            -
          </div>
          <div
            class="flex items-center"
            style="margin-right: 11px; cursor: pointer; margin-top: 14px"
            v-for="(item, index) in paperData.authorList || paperData.authors"
            :key="index"
            @click="goPersonalDetails(item.id || item.scholarId)"
          >
            <el-avatar class="avatar" :size="18" :src="item.avatarUrl" />
            <div style="margin-left: 6px" class="textContent noWrap">
              {{ item.name || item.scholarName }}
            </div>
          </div>
        </div>
      </collapse>
      <!-- 出版物 -->
      <div class="text-title" v-if="paperData.venue !== null">
        <span class="textSpan">出版物：</span>
        <div class="textContent">
          {{ paperData.venue == null ? '-' : paperData.venue }}
        </div>
      </div>
      <!-- 影响因子 -->
      <div class="text-title">
        <span class="textSpan">期刊影响因子(JCR)：</span>
        <div class="textContent">{{ paperData.impactFactor }}</div>
      </div>
      <!-- JCR分区 -->
      <div class="text-title" v-if="paperData.jcrArea">
        <span class="textSpan">JCR分区：</span>
        <div class="textContent">{{ paperData.jcrArea || '-' }}</div>
      </div>
      <!-- 卷号 -->
      <div class="text-title" v-if="paperData.volume">
        <span class="textSpan">卷号：</span>
        <div class="textContent">
          {{ paperData.volume || '-' }}
        </div>
      </div>
      <!-- 发表时间 -->
      <div class="text-title" v-if="paperData.year">
        <span class="textSpan">发表时间：</span>
        <div class="textContent">{{ paperData.year || '-' }}</div>
      </div>
      <!-- 引用次数 -->
      <div class="text-title" v-if="paperData.citationNum !== null">
        <span class="textSpan">引用次数：</span>
        <div class="textContent">
          {{ paperData.citationNum == null ? '-' : paperData.citationNum }}
        </div>
      </div>
      <!-- 关键词 -->
      <div
        class="text-title"
        v-if="paperData.keywords != null && paperData.keywords.length != 0"
      >
        <span class="textSpan">关键词：</span>
        <div style="display: flex; flex-wrap: wrap">
          <div
            v-if="paperData.keywords == null || paperData.keywords.length == 0"
          >
            -
          </div>
          <div
            style="color: #2e1f88"
            v-for="(item, index) in paperData.keywords"
            :key="index"
          >
            {{ item !== '' && item !== '[]' ? item + '；' : '' }}
          </div>
        </div>
      </div>
      <!-- 摘要 -->
      <div class="text-title">
        <span class="textSpan"
          >摘要：<span class="textContent abstract">{{
            paperData.abst ? paperData.abst : '-'
          }}</span></span
        >
      </div>
    </div>
  </div>
</template>

<script>
import collapse from '@/components/heightCollapse';
import { getPaperDetailApi } from '@/api/details';

export default {
  name: 'paperDetail',
  components: {
    collapse,
  },
  data() {
    return {
      paperData: {
        authors: null,
      },
      authors: [],
      authorList: [],
      isShow: false,
      paperId: null,
      paperDetailLoading: false,
    };
  },
  async created() {
    if (process.env.VUE_APP_NAME === 'guojiao') {
      document.title = '论文详情';
    }
    this.paperId = this.$route.query.id;
    this.getPaperDetails();
  },
  methods: {
    // 跳转作者详情
    goPersonalDetails(id) {
      if (id) {
        let obj = {
          name: 'talentDetail',
          query: {
            id: id,
          },
        };
        let routeData = this.$router.resolve(obj);
        window.open(routeData.href, '_blank');
      } else {
        this.$message.warning({
          message: '暂无详情数据',
          type: 'warning',
        });
      }
    },

    // 跳转论文PDF原文
    clickPDFView() {
      if (this.paperData.url != null && this.paperData.url !== '') {
        window.open(this.paperData.url, '_blank');
      }
    },

    // 获取论文详情
    getPaperDetails() {
      this.paperDetailLoading = true;
      getPaperDetailApi(this.paperId)
        .then((res) => {
          this.paperData = res.data;
        })
        .finally(() => {
          this.paperDetailLoading = false;
        });
    },
  },
};
</script>

<style scoped lang="less">
.paper-container {
  display: flex;
  flex-direction: column;
  margin: 10px auto;
  max-width: 1200px;
  //width: 1190px;
}

.go-back {
  color: #667085;
  font-size: 16px;
  margin-top: 20px;
  margin-left: 30px;
  text-align: start;
  margin-bottom: 10px;
  cursor: pointer;
}

.paper-detail {
  //min-height: 800px;
  height: fit-content;
  align-content: center;
  background: #ffffff;
  padding: 25px 30px;
  border-radius: 16px;

  .pdf-view {
    position: relative;

    p {
      top: 10px;
      right: 0;
      position: absolute;
      width: 118px;
      height: 38px;
      line-height: 36px;
      border: 1px solid #0c78c1;
      color: #0c78c1;
    }
  }

  .paper-title {
    //text-align: start;

    .paper-bg {
      color: rgb(0, 91, 172);
      background: #dbeafe;
      padding: 4px 10px;
      border-radius: 4px;
      font-size: 14px;
    }

    .paper-title-style {
      text-align: start;
      line-height: 28px;
      font-size: 20px;
      margin-left: 9px;
      font-weight: bold;
      color: #333333;
    }

    .jcr-view {
      background-color: rgb(0, 91, 172);
      border-radius: 3px;
      font-size: 12px;
      color: white;
      padding: 4px 10px;
      margin-left: 10px;
      max-width: 200px;
    }
  }

  .text-title {
    display: flex;
    margin-top: 14px;
    text-align: start;
  }

  .textSpan {
    color: #667085;
    font-size: 16px;
  }

  .textContent {
    font-size: 16px;
    color: #344054;
  }

  .abstract {
    line-height: 24px;
  }
}

.noWrap {
  white-space: nowrap;
}
</style>
